import { observer } from "mobx-react-lite";
import * as React from "react";

import { MfNode, RenderCtx } from "../../node/MfNode";
import { ZMfNodeGroup } from "../../ZMfNode";
import { groupBlockId } from "./groupBlockId";
import * as styles from "./MfGroupBlockView.module.less";

type PropsMfGroupBlockView = {
  content: MfNode;
  meta: ZMfNodeGroup;
  ctx: RenderCtx;
};

export const MfGroupBlockView: React.FC<PropsMfGroupBlockView> = observer(
  (props) => {
    const { content, meta, ctx } = props;
    const { Render } = content;
    return (
      <div className={styles.block}>
        <div className={styles.header} id={groupBlockId(meta)}>
          <div className={styles.title}>{meta.title}</div>
        </div>
        <Render ctx={ctx} />
      </div>
    );
  },
);
